const DATA_TEST_IDS = {
  utilsGetLatLongLink: 'common__utils_get-lat-long-link',
} as const;

export default DATA_TEST_IDS;
